import { Common } from '../common';
import { Nullable } from '../models/common';
import {
  Preference,
  PreferenceDetail,
  PreferenceOptions,
} from '../models/user/preferences';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: {
    userId: string;
    preference: PreferenceDetail;
  }): Promise<Preference> {
    const userId = values.userId;
    const url = this.common.constructPath(`/users/${userId}/preferences`);
    return this.common.postJSON(url, values);
  }

  async update(values: {
    userId: string;
    preferenceDetail: PreferenceDetail;
  }): Promise<Preference> {
    const userId = values.userId;
    const url = this.common.constructPath(`/users/${userId}/preferences`);
    return this.common.putJSON(url, values);
  }

  async get(
    userId: string,
    includePreferenceDescriptions: true,
  ): Promise<{
    preferences: PreferenceDetail;
    preferenceDescriptions: PreferenceOptions;
  }>;
  async get(userId: string): Promise<{ preferences: PreferenceDetail }>;
  async get(userId: string, includePreferenceDescriptions?: true) {
    let url = this.common.constructPath(`/users/${userId}/preferences`);
    if (includePreferenceDescriptions) {
      url = `${url}?includePreferenceDescriptions=true`;
    }

    return this.common.getJSON(url);
  }

  async set(
    userId: string,
    values: Nullable<PreferenceDetail>,
  ): Promise<{ preferences: PreferenceDetail }> {
    const url = this.common.constructPath(`/users/${userId}/preferences`);
    return this.common.patchJSON(url, {
      preferences: values,
    });
  }
}
